import type { FormDefinition } from '@/core/templates/types'

export default {
  title: 'Maßnahme',
  sections: {
    Maßnahme: {
      fields: [
        { id: 'Maßnahme.Nummer', control: 'text-or-date' },
        { id: 'Maßnahme.Bezeichnung', control: 'text-or-date' },
      ],
    },
    Details: {
      fields: [
        { id: 'Details.Inhalt', control: 'text', dictation: true },
        { id: 'Details.Durchführungsort', control: 'select', options: ['online', 'offline'] },
        { id: 'Details.Durchführungsform', control: 'select', options: ['Einzel', 'Gruppe'] },
      ],
    },
    Ansprechpartner: {
      fields: [{ id: 'Ansprechpartner.Ansprechpartner', control: 'select', options: [] }],
    },
    Anwesenheit: {
      fields: [{ id: 'Anwesenheit.Stichzeit', control: 'input', inputType: 'time' }],
    },
    Aktivierung: {
      fields: [{ id: 'Aktivierung.Zuständig für Aktivierung', control: 'select', options: [] }],
    },
  },
} satisfies FormDefinition
